<template>
  <editor-form :can-back="true" @submit.prevent="showConfirmModal" @back="toViewer">
    <vuex-text-form-item label="氏名" bind="name" :required="true" />
    <vuex-text-form-item label="氏名（カナ）" bind="name_kana" :required="true" />
    <switch-browse-item label="管理者" :checked="isSupervisor" :show-readonly="true" />
    <text-browse-item :value="email" label="メールアドレス" />
    <vuex-password-form-item bind="password" placeholder="変更する場合のみパスワード入力" label="新しいパスワード" />
    <vuex-switch-form-item label="２段階認証" bind="use_two_step_authentication" />
    <vuex-textarea-form-item bind="contact" label="連絡先" />
    <vuex-text-form-item label="店舗名" bind="office" />
    <vuex-text-form-item label="部署名" bind="department" />
  </editor-form>
  <teleport to="body">
    <edit-confirm-modal @update="doUpdate" ref="confirmModal" />
  </teleport>
</template>

<script>
import {mapState} from "vuex";
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import EditorForm from "@/views/templates/forms/EditorForm";
import VuexTextFormItem from '@/views/molecules/formItems/VuexTextFormItem'
import SwitchBrowseItem from '@/views/molecules/browseItems/SwitchBrowseItem'
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import VuexPasswordFormItem from "@/views/molecules/formItems/VuexPasswordFormItem";
import VuexTextareaFormItem from "@/views/molecules/formItems/VuexTextareaFormItem";
import EditConfirmModal from '@/views/molecules/modals/EditConfirmModal';
import VuexSwitchFormItem from "@/views/molecules/formItems/VuexSwitchFormItem";

export default {
  name: "AccountEditor",
  components: {
    EditorForm,
    VuexTextFormItem,
    SwitchBrowseItem,
    TextBrowseItem,
    VuexPasswordFormItem,
    VuexTextareaFormItem,
    EditConfirmModal,
    VuexSwitchFormItem,
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'account_form'
  },
  computed: {
    ...mapState('account_form', {
      isSupervisor: state => state.data.is_supervisor,
      email: state => state.data.email
    }),
  },
  methods: {
    loadPage() {
      return this.$store.dispatch('account_form/load').catch(() => this.$root.failApi());
    },
    showConfirmModal() {
      this.$refs.confirmModal.show();
    },
    doUpdate() {
      this.$store.dispatch('account_form/update').then(() => {
        this.$router.push({name: 'AccountViewer'});
      }).catch(reason => this.$root.failApi(reason));
    },
    toViewer() {
      this.$router.push({name: 'AccountViewer'});
    },
  }
}
</script>
